import { Component, OnInit, ViewChild } from '@angular/core';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import {FormBuilder, FormControl, FormGroup, FormsModule, Validators} from '@angular/forms';
import { wayToPay } from '../../../models/wayToPay';
import { MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-changeToCashOut',
  styleUrls: [],
  templateUrl: 'changeToCashOut.component.html',
  providers: [generalService]
})


export class modalChangeToCashOutComponent implements OnInit{
  constructor(public dataService: DataService,
              public _generalService: generalService,
              private formBuilder: FormBuilder,
              ) {
  }
  public dataSource = new MatTableDataSource<wayToPay>();
  public displayedColumns : string [] = ['acciones','WAY_TO_PAY_ID','AMOUNT'];
  public way_to_payControl = new FormControl(null);
  public AMOUNTControl = new FormControl({ value: null, disabled: true });
  public seEstaEditando = false;
  public list_way_to_pay: wayToPay[] = [];
  public list_way_to_pay_aux: wayToPay[] = [];
  public dataWayToPay: any [] = [];
  public listWayToPay: any [] = [];
  public indiceEditando: number | null = null; 
  form:FormGroup;
  To_Cash_Out = [
    {valuedtoCashout : 0, value: 'No'},
    {valuedtoCashout : 1, value: 'Si'}
  ]

  ngOnInit() {   
    this.getdata();
    this.id_to_cash_out = this.dataService.dialogRef._containerInstance._config.data.toCashOut;
    this.idPago = this.dataService.dialogRef._containerInstance._config.data.idpago;

    this.form = this.formBuilder.group({
      To_Cash_Out:  ""
    });
  
    this.variableAux = this.id_to_cash_out;
    this.valorOriginal = this.id_to_cash_out;
    this.getDataWayToPay();
  }

  // --------------------Declaracion de variables ------------------
  public id_to_cash_out: any;
  public idPago : any;
  public palabra: string;
  public cambioToCashOut: any;
  public stringDetalles: string;
  public variableAux: any;
  public valorOriginal: any;
  public desabilitarDDL: any = false;

   // --------------------Declaracion de Funciones ------------------
  cerrarModal() {
    this.dataService.dialogRef.close(0);
  }

  ngModelChange(valorSeleccionado){
    this.valorOriginal == valorSeleccionado? this.desabilitarDDL = false: this.desabilitarDDL = true;
  }

  cambiarToCashOut(){
    this.cambioToCashOut = this.variableAux;

    let params: any = {
      cambioToCashOut: this.cambioToCashOut,
      idPago:this.idPago,
    }
    let metodo = 'HistorialPagos/changeToCashOut';
    let metodo2 = 'HistorialPagos/changewayToPayDetalle';

    let params2: any = {
      detallewayToPay: this.dataSource.filteredData,
    }

    
    this._generalService.metodoCallParams(params, metodo).subscribe(
      (result) => {
      const arrayResult = JSON.parse(result);

      this._generalService.metodoCallParams(params2, metodo2).subscribe(
        (result) => {
        const arrayResult1 = JSON.parse(result);
      },(error) => {
        const errorMsj =  error as any;
        console.log(errorMsj); 
      });

      this.dataService.dialogRef.close('1');
      
    },
    (error) => {
      const errorMsj =  error as any;
      console.log(errorMsj); 
    });
  }
  
  getdata(){
    const params = {}
    let link = 'HistorialPagos/getWayToPayList/';
    this._generalService.metodoCallParams(params, link, true).subscribe(
      (result) => {
        const tableResult = JSON.parse(result);
        this.listWayToPay = tableResult.Table;

      }, (error) => {
        console.log(error as any);
    });
  }
  getDataWayToPay(){
   this.list_way_to_pay = [];
    const params = {
      idPago:this.idPago,
    }
    let link = 'HistorialPagos/getWayToPay/';
    this._generalService.metodoCallParams(params, link, true).subscribe(
      (result) => {
        const tableResult = JSON.parse(result);
        this.dataWayToPay = tableResult.Table;
         
        if ( this.dataWayToPay.length !== 0){
          for (let i = 0; i < this.dataWayToPay.length; i++) {
            this.dataWayToPay[i].index = i;
            
            const modeloAuxiliar: any = {
              index: i,
              PAYMENT_WAY_TO_PAY_ID:this.dataWayToPay[i].PAYMENT_WAY_TO_PAY_ID,
              WAY_TO_PAY_ID: this.dataWayToPay[i].WAY_TO_PAY_ID,
              AMOUNT: this.dataWayToPay[i].AMOUNT,
              WAY_TO_PAY_NAME: this.dataWayToPay[i].NAME,
            };

            this.list_way_to_pay.push(modeloAuxiliar);
            
          }

          this.dataSource.data = this.list_way_to_pay;
          //console.log(this.dataSource.data)
        }
      }, (error) => {
        console.log(error as any);
    });
  }
  
  establecerDetalle(way_To_Pay: wayToPay, index: number) {
    this.seEstaEditando = true;
    this.indiceEditando = index;  // Establecer el índice del elemento que se está editando

    // Inicializar los controles con los valores del registro seleccionado
    this.AMOUNTControl.setValue(way_To_Pay.AMOUNT);
    this.way_to_payControl.setValue(way_To_Pay.WAY_TO_PAY_ID);  // Asegúrate de que el FormControl se llama 'way_to_payControl'
  }

  cancelarAccion() {
      this.seEstaEditando = false;
      this.AMOUNTControl.reset();
      this.way_to_payControl.reset();  // También resetear el FormControl del tipo de pago
  }

  guardarDetalleRow(way_To_Pay: wayToPay, index: number) {
    
    // Obtener el nuevo valor de los controles
    const nuevoWayToPay = this.way_to_payControl.value;
    const nuevoAmount = this.AMOUNTControl.value;

    // Buscar el nombre del método de pago usando el nuevo ID
    const formaPago = this.listWayToPay.find(p => p.WAY_TO_PAY_ID === nuevoWayToPay);

    // Actualizar el elemento en la lista
    this.list_way_to_pay = this.list_way_to_pay.map(element => {
      if (element.index === index) {
        return {
          ...element,
          WAY_TO_PAY_ID: nuevoWayToPay,
          AMOUNT: nuevoAmount,
          WAY_TO_PAY_NAME: formaPago ? formaPago.NAME : element.WAY_TO_PAY_ID // Asignar el nombre del método de pago si existe
        };
      }
      return element;
    });

    // Actualizar la lista auxiliar
    this.list_way_to_pay_aux = [...this.list_way_to_pay];
    
    // Actualizar la fuente de datos
    setTimeout(() => {
      this.dataSource.data = this.list_way_to_pay_aux;
    });

    // Finalizar el modo de edición
    this.seEstaEditando = false;
    //console.log(this.dataSource.data);
  }



  
  
}






// WEBPACK FOOTER //
// ./src/app/cliente-sae/historial-pagos/cahngeToCashOut/changeToCashOut.component.ts